import React from 'react';
import { Flex, Text, chakra } from '@chakra-ui/react';

type T = {
  bold: string;
  text: string;
  isTruncated?: boolean;
  children?: any[] | JSX.Element;
};

export const TextFlexRowWithChildren = ({ bold, text, isTruncated, children }: T) => {
  return (
    <Flex
      align="flex-start"
      alignItems="center"
      justify={{ base: 'space-between', md: 'flex-start' }}
      flex={1}
      maxW="100%"
      w={{ base: '100%', md: 'auto' }}
    >
      <Text fontSize="sm" isTruncated={isTruncated} data-testid="text-row-text">
        <chakra.span fontWeight="600">{bold}</chakra.span>&nbsp;&nbsp;
        {text}
      </Text>
      {children}
    </Flex>
  );
};
